import {faSpinnerThird} from '@fortawesome/pro-regular-svg-icons/faSpinnerThird';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useCallback, useEffect, useRef} from 'react';
import {Animated} from 'react-native';

const LoadingSpinner = () => {
  const spinAnim = useRef(new Animated.Value(0)).current;

  const startSpin = useCallback(() => {
    // Will change spinAnim value to 1 in 5 seconds
    Animated.loop(
      Animated.sequence([
        Animated.timing(spinAnim, {
          toValue: 1,
          duration: 1000,
          useNativeDriver: true,
        }),
      ]),
      {
        iterations: -1,
      },
    ).start();
  }, [spinAnim]);

  const spin = spinAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  });

  useEffect(() => {
    startSpin();
  }, [startSpin]);

  return (
    <Animated.View
      style={[{transform: [{rotate: spin}]}, {alignItems: 'center'}]}
    >
      <FontAwesomeIcon
        icon={faSpinnerThird}
        color="#B0B2B9"
        style={{
          fontSize: 48,
        }}
      />
    </Animated.View>
  );
};

export default LoadingSpinner;
